import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {VwuiAngularModule, VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TranslatePipe} from '@ngx-translate/core';
import {FormUtil} from '../../utils';
import {TrackingService} from '../../services';
import {ProjectType} from '../../models/project-analysis';
import {FormControl, FormGroup} from '@ng-stack/forms';

export interface ProjectTypeModalData {
    title: string;
    saveText: string;
    data?: ProjectType;
}

@Component({
    selector: 'app-create-update-project-type-modal',
    templateUrl: './create-update-project-type-modal.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ReactiveFormsModule, TranslatePipe, VwuiAngularModule]
})
export class CreateUpdateProjectTypeModalComponent {
    public readonly modalRef = inject(VwuiModalRef);
    public readonly modalConfig = inject<VwuiModalConfig<ProjectTypeModalData>>(VwuiModalConfig);
    private readonly trackingService = inject(TrackingService);

    public readonly title: string;
    public readonly saveText: string;
    public readonly form: FormGroup;

    private readonly data?: ProjectType;

    constructor() {
        this.title = this.modalConfig.data.title;
        this.saveText = this.modalConfig.data.saveText;
        this.data = this.modalConfig.data.data;

        this.form = new FormGroup({
            name: new FormControl(this.data?.name ?? '', Validators.required),
            description: new FormControl(this.data?.description ?? '')
        });
    }

    public submit(): void {
        try {
            FormUtil.validate(this.form);

            if (!this.form.valid) return;

            const updatedValues: ProjectType = {
                ...this.data,
                name: this.form.value.name,
                description: this.form.value.description
            };

            this.modalRef.close(updatedValues);
        } catch (e) {
            console.error('Updating item failed: ', e);
            this.trackingService.exception(e);
        }
    }
}
